import { render, staticRenderFns } from "./AssessmentGenerate.vue?vue&type=template&id=179cf118&scoped=true"
import script from "./AssessmentGenerate.vue?vue&type=script&lang=js"
export * from "./AssessmentGenerate.vue?vue&type=script&lang=js"
import style0 from "./AssessmentGenerate.vue?vue&type=style&index=0&id=179cf118&prod&scoped=true&lang=css"
import style1 from "./AssessmentGenerate.vue?vue&type=style&index=1&id=179cf118&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179cf118",
  null
  
)

export default component.exports